import { api } from './client';
import type { Agent } from '@/types';

export function listAgents(limit = 100): Promise<Agent[]> {
  return api<Agent[]>(`/api/agents?limit=${limit}`);
}

export function getAgent(id: string): Promise<Agent> {
  return api<Agent>(`/api/agents/${id}`);
}

export function deleteAgent(id: string): Promise<void> {
  return api<void>(`/api/agents/${id}`, { method: 'DELETE' });
}

export function getLatestAgentVersion(): Promise<{ version: string | null }> {
  return api<{ version: string | null }>('/api/agents/latest-version');
}

export function updateAgent(id: string): Promise<{ status: string }> {
  return api<{ status: string }>(`/api/agents/${id}/update`, { method: 'POST' });
}
